import React, {Fragment, useEffect, useState} from 'react';
import Tabs from 'react-responsive-tabs';
import {
    getAccessedFormsFromProfile,
    getAppType,
    removeLastChar
} from "../../../../Common/Appcommon";
import GlobalSettings from './globalsettings';
import LegacyCallSettings from '../../LegacySettings/LegacyCallSettings';

const UserMobileSettings = props => {

    let [selectedTab,setSelectedTab] = useState(0);
    let [modifiedTabs,setModifiedTabs] = useState([{}]);
    useEffect(() => {
        getProfileAccessedFormTabs();
         setSelectedTab(0);
    },[])
    
    let tabsContent = [
        
        {
            title: 'User Settings',
            content: <LegacyCallSettings />,
            name : 'user_mobile_settings',
            formname : 'table_79',
            appType : '2',
        },
        {
            title: 'Global Settings',
            content: <GlobalSettings />,
            name : 'field_custom',
            formname : 'table_21',
            appType : '2',
        }
    ];

    async function getProfileAccessedFormTabs() {
        let tabList = "";
        tabsContent.map((forms, index) => {
            tabList += forms['formname']+",";
        });
        tabList = removeLastChar(tabList);
        let responce = await  getAccessedFormsFromProfile(tabList);
        let curAppType = getAppType();
        if(responce.issuccess){
            let modifiedTab = [];
            let data = responce.data;
            data.map((forms, indexs) => {
                tabsContent.map((tab, index) => {
                    if((tab.formname === data[indexs]) && (tab.appType === curAppType || tab.appType === "0") ){
                        modifiedTab.push(tab);
                    }
                })
            })
            setModifiedTabs(modifiedTab);
        }
    }

    function getTabs() {
        return modifiedTabs.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }

    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                selectedTabKey={selectedTab}
                items={getTabs()}/>
        </Fragment>
    )

}

export default UserMobileSettings;
